"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

require("./Grid.css");

var _Col = _interopRequireDefault(require("./Col"));

var _Row = _interopRequireDefault(require("./Row"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
outermost wrapper for grid
*/
function Grid(_ref) {
  var Component = _ref.componentEl,
      fluid = _ref.fluid,
      className = _ref.className,
      children = _ref.children;
  var cssClasses = [];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  if (fluid) cssClasses.push('st_container-fluid');
  if (!fluid) cssClasses.push('st_container');
  return /*#__PURE__*/_react["default"].createElement(Component, {
    className: cssClasses.join(' ')
  }, children);
}

Grid.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: utils.componentEl.props,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** whether Grid takes up all available horizontal space, or has fixed width at breakpoints */
  fluid: _propTypes["default"].bool
};
Grid.defaultProps = {
  componentEl: utils.componentEl.defaults,
  className: null,
  fluid: true
};
Grid.Row = _Row["default"];
Grid.Row.displayName = 'Grid.Row';
Grid.Col = _Col["default"];
Grid.Col.displayName = 'Grid.Col';
var _default = Grid;
exports["default"] = _default;